module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "poem1"
  }, [_vm._v("For now, this fearful night,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("There is no stir, or walking in the streets;")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("And the complexion of the element")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("In favour’s like the work we have in hand,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Most bloody, fiery, and most terrible.")]), _vm._v(" "), _c('p', {
    staticClass: "pright"
  }, [_vm._v("—Shakespeare")]), _vm._v(" "), _c('p', {
    staticClass: "pright"
  }, [_c('i', [_vm._v("Julius Caesar")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24716202","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f006.vue
// module id = 75
// module chunks = 0